import React from "react";
import randString from "../../../utils/randomString";

type Props = {
  placeholder: string;
  label: string;
  register?: any;
  name?: any;
  errors?: any;
  disabled?: any;
};

const PasswordField = (props: Props) => {
  const {
    placeholder,
    register,
    label,
    name,
    errors,
    disabled = false,
  } = props;
  const id = randString(10);
  return (
    <div className="w-full">
      <label className="font-medium">{label}</label>
      <input
        id={id}
        type="password"
        name={name}
        className="w-full p-2 border rounded-md focus:outline-none mt-1"
        placeholder={placeholder}
        {...register(name)}
        disabled={disabled}
      />
      {errors ? <p className="text-red-500">{errors?.message}</p> : ""}
    </div>
  );
};

export default PasswordField;
